import React from "react";
import ErrorPageWrapper from "./page-wrapper";
const AuthErrorPage = ({ handleLogout, accessDenied }) => {
    return React.createElement(ErrorPageWrapper, { handleLogout: handleLogout, accessDenied: accessDenied, isHeightRequired: true });
};
export default AuthErrorPage;
